const data = {}

export default data
